<template lang="pug">
div
    div
        h3(style='padding: 15px 0px; font-weight: 700') {{ $t('mensagens.territorio.arquivo.tituloProdutor') }}
        el-card
            h4(style='color: #3b3b3b; margin-bottom: 20px; font-weight: 500') {{ $t('mensagens.territorio.arquivo.subTitulo') }}
            UploadArquivo(
                style='margin-bottom: 15px',
                @add='onAdd',
                @delete='onDelete',
                :isProdutor='true',
                :options='arquivosProdutor'
            )
                | {{ $t('mensagens.territorio.arquivo.arquivo') }}
            
    div
        h3(style='padding: 15px 0px; font-weight: 700') {{ $t('mensagens.territorio.arquivo.tituloEmpresa') }}
        el-card
            h4(style='color: #3b3b3b; margin-bottom: 20px; font-weight: 500') {{ $t('mensagens.territorio.arquivo.subTitulo') }}
            UploadArquivo(
                style='margin-bottom: 15px',
                @add='onAdd',
                @delete='onDelete',
                :isProdutor='false',
                :options='arquivosNaoProdutor'
            )
                | {{ $t('mensagens.territorio.arquivo.arquivo') }}
</template>
<script>
import UploadArquivo from './UploadArquivo.vue';

export default {
    components: {
        UploadArquivo
    },
    props: {
        items: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        arquivosProdutor() {
            let arquivosProdutor = this.items.filter(item => item.arquivoProdutor);
            return arquivosProdutor;
        },
        arquivosNaoProdutor() {
            let arquivosNaoProdutor = this.items.filter(item => !item.arquivoProdutor);
            return arquivosNaoProdutor;
        }
    },
    methods: {
        onAdd(file) {
            this.$emit('add', file);
        },
        onDelete(fileId) {
            this.$emit('delete', fileId);
        }
    }
};
</script>
